import Vue from 'vue'
import Vuex from 'vuex'
import session from './session'
import equipment from './equipment'
import loading from './loading'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    session,
    equipment,
    loading
  }
})
